import { atom } from 'recoil';
import defaultProjectsTotal from 'ProjectManager/Project/List/recoil/totalCount/defaultProjectsTotal';

const projectsTotalCountWithoutFiltersAtom = atom({
    key: 'projectManagement_projectsListTotalCountWithoutFilters',
    default: defaultProjectsTotal,
});

export default projectsTotalCountWithoutFiltersAtom;
